import { render, staticRenderFns } from "./EDeal.vue?vue&type=template&id=fac0f3cc&scoped=true"
import script from "./EDeal.vue?vue&type=script&lang=js"
export * from "./EDeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac0f3cc",
  null
  
)

export default component.exports